import React from "react";
import { serviceIdToNameMap } from "../../../facturacion/helpers/utils";
import HelpIcon from "./HelpIcon";

export interface ValueResult {
  now: number;
  prev: number;
  diff: number;
  explanation: string;
}

export interface ServiceCountResponse {
  [key: string]: ValueResult;
}

const serviceIdToName = (serviceId: string | null): string => {
  if (!serviceId) return "";
  return serviceIdToNameMap[serviceId] ?? serviceId;
};

interface KpiConsumptionProps {
  data: ServiceCountResponse;
}

export const KpiConsumption: React.FC<KpiConsumptionProps> = ({ data }) => {
  return (
    <>
      {
        Object.entries(data).map(([serviceId, { now, diff, explanation }]) => (
          <div style={{ backgroundColor: "rgb(0,0,0,0.2)", padding: "10px", borderRadius: "8px", textAlign: "center", width: "130px", margin: "5px" }} key={serviceId}>
            <div key={serviceId}>
              <div style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "end" }}>
                <HelpIcon text={explanation} />
              </div>
              <div >
                <p className="text-huge text-bold" style={{ margin: "0px" }}>{now}</p>
                <p className="text-x-large text-bold" style={{ margin: "0px", color: diff > 0 ? "#66FF66" : "#FF8A37" }}>{diff}</p>
                <p className="text-x-large text-bold" style={{ margin: "0px" }}>{serviceIdToName(serviceId)}</p>
              </div>
            </div>
          </div>
        ))
      }
    </>
  );
};
